import { useRouter } from 'next/router';

import { FormField, FormHelp, Input, Label } from '@zillow/constellation-10';

import { useRentalManagerUserPropertyEditV2WebApiHandler_contactName } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import { useGetListingDetails } from '../../../hooks/queries/properties';
import { useFieldSave } from '../../../hooks/useFieldSave';
import { usePropertyEditMutation } from '../../../hooks/usePropertyEditMutation';

const inputName = 'contactName';

const NameFormField = () => {
  const router = useRouter();
  const listingAlias = router.query.listingAlias as string;
  const { data: listingDetails } = useGetListingDetails(listingAlias);

  const initialValue = listingDetails?.contactName ?? '';

  const updateMutation = usePropertyEditMutation({
    mutationHook: useRentalManagerUserPropertyEditV2WebApiHandler_contactName,
    applyToCache: true,
    meta: { context: { api: 'RentalManagerUserPropertyEditV2WebApiHandler_contactName' } },
  });

  const field = useFieldSave({
    fieldName: inputName,
    initialValue,
    mutation: updateMutation,
    buildMutationVariables: (value) => ({
      postData: { listingAlias, contactName: value },
    }),
  });

  return (
    <FormField
      data-testid="NameFormField"
      label={<Label>Name</Label>}
      error={!!field.error}
      description={<FormHelp>{field.error}</FormHelp>}
      required={true}
    >
      <Input
        name={inputName}
        className="fs-mask"
        value={field.value}
        onChange={(e) => field.onChange(e.target.value)}
        onBlur={field.onBlur}
      />
    </FormField>
  );
};

export default NameFormField;
